import { MenuItem, Stack } from "@mui/material";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { allIcons } from "../../../assets";
import AppContainer from "../../../components/AppContainer";
import AppLoader from "../../../components/AppLoader";
import CustomDropDown from "../../../components/CutomDropDown";
import { getAllWorkersAppointment } from "../../../services/worker/appointmentApiFn";
import { handleOpenSnackBar } from "../../../utils";
import NavigationDrawer from "./../../../components/NavigationDrawer/index";
import Appointment from "./Appointment";
import WorkerCalendar from "./WorkerCalendar";
import { setSearchKeys } from "../../../lib/slices/search_key_slice";
import { t } from "i18next";

const WorkerAppointment = () => {
  const dispatch = useDispatch();
  const openAppointmentDialog = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [allAppointments, setAllAppointments] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const userData = useSelector((state) => state.userData.user);
  const searchKeys = useSelector((state) => state.SearchKeysReducer.searchKeys);

  useEffect(() => {
    if (userData) {
      fetchAllAppointments(userData?._id);
    }
  }, [userData, searchKeys.workerAppointmentStatus]);

  const fetchAllAppointments = async () => {
    try {
      setIsLoading(true);
      const response = await getAllWorkersAppointment(
        userData?._id,
        searchKeys.workerAppointmentStatus
      );
      if (response.data.status === "success") {
        let data = response.data.data?.map((x) => ({
          ...x,
          start: new Date(x.start),
          end: new Date(x.end),
        }));
        console.log(data, "datadatadatadatadatadata");
        setAllAppointments(data);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectEvent = (event) => {
    setSelectedEvent(event);
    openAppointmentDialog.current.openDrawer({
      data: event,
      getData: fetchAllAppointments,
    });
  };

  const renderHeaderItems = () => {
    return (
      <Stack flex={1} alignItems={"flex-end"}>
        <CustomDropDown
          size={"small"}
          icon={<img src={allIcons.statusDropDownIcon} width={20} />}
          value={searchKeys.workerAppointmentStatus}
          onChange={(e) => {
            dispatch(
              setSearchKeys({
                ...searchKeys,
                workerAppointmentStatus: e.target.value,
              })
            );
          }}
          formStyleProps={{
            width: { xs: "100%", md: "40%" },
          }}
        >
          <MenuItem value={"All"}>{t("all")}</MenuItem>
          <MenuItem value={"pending"}>{t("pending")}</MenuItem>
          <MenuItem value={"accepted"}>{t("arrived")}</MenuItem>
          <MenuItem value={"started"}>{t("started")}</MenuItem>
          <MenuItem value={"completed"}>{t("completed")}</MenuItem>
        </CustomDropDown>
      </Stack>
    );
  };

  return (
    <NavigationDrawer>
      <AppLoader isVisible={isLoading} />
      <AppContainer
        primaryHeading={`${t("today")} ${moment(new Date()).format(
          "DD/MM/YYYY"
        )}`}
        secondaryHeading={t("calendarShowAllDateTime")}
        headProps={renderHeaderItems()}
      >
        <WorkerCalendar
          allAppointments={allAppointments}
          handleSelectEvent={handleSelectEvent}
        />
      </AppContainer>
      <Appointment ref={openAppointmentDialog} selectedEvent={selectedEvent} />
    </NavigationDrawer>
  );
};

export default WorkerAppointment;
